<template>
  <v-dialog
    v-model="dialog"
    persistent
  >
    <template #activator="{on}">
      <v-btn
        text
        color="primary"
        v-on="on"
      >
        Informar lista
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span>Informar lista personalizada de ID's</span>
      </v-card-title>
      <v-card-text>
        <form-group>
          <v-row class="py-6">
            <span>A lista pode ser
              iformada por quebra de linha, vírgula ou espaços</span>
          </v-row>
          <v-row>
            <v-textarea
              id="input:list"
              v-model="list"
              label="ID's dos usuários"
              rows="5"
              outlined
              required
              type="number"
            />
          </v-row>
          <v-row>
            <v-textarea
              id="input:clientIds"
              v-model="clientIds"
              label="ID's dos clientes"
              rows="5"
              outlined
              required
              type="number"
            />
          </v-row>
        </form-group>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          @click="() => dialog = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="success"
          class="ml-2"
          @click="save()"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import FlatListMixin from 'Arch/mixins/FlatListMixin';

export default {
  name: 'NotificationCustomListBtn',
  components: { FormGroup },
  mixins: [RulesMixin, FlatListMixin],
  data: () => ({
    dialog: false,
    list: '',
    clientIds: [],
  }),
  computed: {
    overrideFlatList() {
      return (items) => {
        const list = this.splitLoop(
          this.makeSplitList(
            items,
          ),
        );
        if (Array.isArray(list)) {
          return this.onlyArr(
            list,
          ).filter(Boolean);
        }
        return [list];
      };
    },
    getList() {
      return (list) => this.overrideFlatList(
        list,
      ).map(Number)
        .filter(Boolean);
    },
    clientFlatList() {
      return this.getList(
        this.clientIds,
      );
    },
    userFlatList() {
      return this.getList(
        this.list,
      );
    },
  },
  methods: {
    save() {
      this.handleUsersFilter({});
      this.handleUsersList(
        this.userFlatList,
      );
      this.handleClientList(
        this.clientFlatList,
      );
      this.$nextTick(
        () => {
          this.dialog = false;
        },
      );
    },
  },
  inject: {
    handleUsersList: {
      default() {
        return (v) => v;
      },
    },
    handleUsersFilter: {
      default() {
        return (v) => v;
      },
    },
    handleClientList: {
      default() {
        return (v) => v;
      },
    },
  },
};
</script>
